var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestPostArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.039 0.343018L10.628 1.76102L13.898 5.01602L0.292969 5.02902L0.294969 7.02902L13.863 7.01602L10.648 10.246L12.065 11.656L17.709 5.98602L12.039 0.343018Z",
    fill: "#F37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestPostArrow);
export default __webpack_public_path__ + "static/media/latestPostArrow.fbe13d5646f4b347cf014d76d230555c.svg";
export { ForwardRef as ReactComponent };